import {createEntityAdapter} from '@reduxjs/toolkit'
import { IProvider } from '../../types'

export const providerAdapter = createEntityAdapter<IProvider>()